// extracted by mini-css-extract-plugin
module.exports = {"nameTag":"NameTag-module--nameTag--I0rHK"};